//opens widget to schedule meetings
export const openScaduleWidget = () => window.Calendly.initPopupWidget({url:'https://calendly.com/fastcast4u/promo'});